export const ADTYPE = {
  CTN: 'ctn',
  TABOOLA: 'taboola',
  DFP: 'dfp',
};

const getAdDivId = (jarvisad, adData) => {
  const { data } = adData;
  const { groupName, jname } = data;

  let { divId } = data;
  if (!divId || divId === 'undefined') {
    divId = jarvisad.divId;
  }

  if (jarvisad.replace) {
    divId = jarvisad.divId;
  }
  if (adData.msid) {
    divId += `-${adData.msid}`;
  }

  if (groupName && jname) {
    divId += `-${jname}`;
  }

  return divId;
};
const markAndAllot = multiAds => {
  const isClient = typeof window !== 'undefined';
  const key = isClient ? 'marked' : 'smarked';
  const { length } = multiAds.filter(r => r[key] === 1);
  const idx = length === multiAds.length ? length - 1 : length;
  const obj = multiAds[idx];
  obj[key] = 1;
  return obj;
};
const updatefromMultipleAds = (jarvisad, isCTN, name) => {
  const { multiAds, size, divId } = jarvisad;

  jarvisad.adCounter = jarvisad.adCounter ? jarvisad.adCounter + 1 : 1;
  let newObj = markAndAllot(multiAds);
  if (newObj) {
    const id = jarvisad.adCounter - 1 || '';
    newObj = {
      name: name + id,
      size,
      ...newObj,
    };
    if (divId) {
      newObj.divId = divId + (newObj.adCounter || id);
      if (isCTN) {
        // TODO:// will remove this | TOIPR-79362
        newObj.msid = newObj.divId;
      }
    }
    return newObj;
  }
  return jarvisad;
};

const failoverupdate = (jfailover, failover) =>
  failover.map((ele, i) => {
    const newUpdate = jfailover[i] || {};
    return { ...ele, ...newUpdate };
  });

const updatedAdData = (jarvisad, adData, name) => {
  const { isCTN, data } = adData;
  const { failover } = data;
  if (jarvisad.failover?.length && failover?.length) {
    jarvisad.failover = failoverupdate(jarvisad.failover, failover);
  }

  if (jarvisad?.multiAds) {
    return updatefromMultipleAds(jarvisad, isCTN, name);
  }

  if (isCTN) {
    return {
      ...data,
      ...jarvisad,
      jarvisad: true,
    };
  }

  return {
    ...data,
    ...jarvisad,
    divId: getAdDivId(jarvisad, adData),
    jarvisad: true,
  };
};

const findAdWithGroupName = (revenueAds, groupName) => {
  try {
    const { content = {} } = revenueAds;
    const groups = [content?.dfp, content?.ctn];
    if (!groupName) return null;
    // last obj from group will be picked
    // eslint-disable-next-line no-restricted-syntax
    for (const group of groups) {
      if (group?.[groupName]) {
        const ads = Object.values(group[groupName]);
        const repeatLastAd = ads[ads.length - 1];
        return {
          ...ads[0],
          ...repeatLastAd,
        };
      }
    }
  } catch (e) {
    // console.error(e);
  }
  return null;
};
const findSpecialAds = (adsArr, name) =>
  adsArr.find(ele => ele?.name === name) || null;

const checkIfCaimpaignActive = (jarvisad, caimpagnAds) => {
  const { checkJarvisIsAdActive } = jarvisad || {};

  if (checkJarvisIsAdActive) {
    if (caimpagnAds && caimpagnAds[checkJarvisIsAdActive]?.isAdActive === 1) {
      return jarvisad;
    }
    return null;
  }
  return jarvisad;
};

const findCodeWithName = (adData, name, skipReplace) => {
  try {
    const { revenueAds, data, caimpagnAds } = adData;
    const { layout = {}, content = {}, specialAds } = revenueAds;
    const { ctn = {}, dfp = {}, mgid = {}, taboola = {} } = content;
    const { mrecs = {}, midAds = {} } = dfp;
    const { groupName } = data;

    const adSources = [
      { source: layout },
      { source: dfp },
      { source: mrecs },
      { source: midAds },
      { source: ctn, adType: ADTYPE.CTN },
      { source: taboola, adType: ADTYPE.TABOOLA },
      { source: mgid, adType: ADTYPE.TABOOLA },
    ];

    let jarvisad = null;
    const dymObj = skipReplace ? { adType: ADTYPE.DFP } : {};

    // Find ad in the prioritized sources
    // eslint-disable-next-line no-restricted-syntax
    for (const { source, adType } of adSources) {
      if (source[name]) {
        jarvisad = source[name];
        if (adType) dymObj.adType = adType;
        break;
      }
    }

    // Check special ads if no match found
    if (!jarvisad && specialAds) {
      jarvisad = findSpecialAds(specialAds, name);
    }
    if (!jarvisad && groupName) {
      jarvisad = findAdWithGroupName(revenueAds, groupName);
    }
    // Handle replacement logic
    if (jarvisad?.replacewith && !skipReplace) {
      const jAd = findCodeWithName(adData, jarvisad.replacewith, true);
      return jAd || jarvisad;
    }

    if (jarvisad?.loadType === 'ssr') {
      jarvisad = checkIfCaimpaignActive(jarvisad, caimpagnAds);
    }

    // Combine results if jarvisad is found
    if (jarvisad) {
      return jarvisad.multiAds ? jarvisad : { ...dymObj, ...jarvisad };
    }

    // Fallback to parent name search if not skipping replace
    if (!skipReplace) {
      const parentName = name.slice(0, -1);
      const parentAd = findCodeWithName(adData, parentName, true);
      if (parentAd?.multiAds) {
        return parentAd;
      }
    }

    return null;
  } catch (error) {
    // console.error(error);
    return null;
  }
};

// eslint-disable-next-line import/prefer-default-export
export const findJarvisAdCode = adData => {
  try {
    if (!adData || typeof adData !== 'object') {
      return null;
    }

    const { data = {}, revenueAds, isNewGam } = adData;
    const { name, jname } = data;
    const adName = jname || name;

    if (!revenueAds || !Object.keys(revenueAds).length || !adName) return null;
    const jarvisAd = findCodeWithName(adData, adName);

    if (jname && !jarvisAd) {
      return { jdisabled: true };
    }

    if (jname) {
      data.name = jname;
    }

    if (jarvisAd) {
      const updatedAd = updatedAdData(jarvisAd, adData, adName);
      if (!isNewGam && updatedAd?.adCodeOldGam) {
        updatedAd.adCode = updatedAd.adCodeOldGam;
      }
      return updatedAd;
    }
    return null;
  } catch (error) {
    // console.error(error);
    return null;
  }
};
